export const FLIGHT_SEARCH_REQUEST_PENDING_STATUS = 'pending';
export const FLIGHT_SEARCH_REQUEST_COMPLETE_STATUS = 'complete';
export const FLIGHT_SEARCH_REQUEST_ERROR_STATUS = 'error';
export const FLIGHT_SEARCH_REQUEST_IDLE_STATUS = 'idle';
